class Slider {
    constructor(el, items, controls, count, gutter = 30, nav, pause, autoplay = false, autoplayTimeout = 6000, speed = 1000) {
        this.scope = el;
        this.items = items;
        this.count = count ? count : false;
        this.prevButton = controls ? controls[0] : false;
        this.nextButton = controls ? controls[1] : false;
        this.gutter = gutter;
        this.nav = nav ? nav : false;
        this.autoplay = autoplay;
        this.autoplayTimeout = autoplayTimeout;
        this.pauseElement = pause;
        this.isPlaying = autoplay;
        this.autoplayInterval = null;
        this.speed = speed;
        this.buildSlider();
        this.indexButtons();
    }

    removeFocusableItems(items) {
        items.forEach(slide => {
            const tabIndexVal = (slide.classList.contains('tns-slide-active')) ? "" : -1;
            slide.querySelectorAll('a, button').forEach(link => link.tabIndex = tabIndexVal);
        });
    }

    buildSlider() {
        let options = {
            container: this.items,
            mouseDrag: true,
            controls: true,
            loop: this.autoplay,
            gutter: this.gutter,
            prevButton: this.prevButton,
            nextButton: this.nextButton,
            navContainer: this.nav,
            autoHeight: false,
            autoplay: false,
            speed: this.speed,
            autoplayButtonOutput: false,
            preventScrollOnTouch: false,
            onInit: () => {
                this.removeFocusableItems(this.items.querySelectorAll('.tns-item'));
                if (this.pauseElement !== undefined) {
                    this.bindPause();
                }
                if (this.autoplay) {
                    this.startAutoplay();
                }
            },
            responsive: {
                768: {
                    items: this.count ? this.count[0] : 2
                },
                1024: {
                    items: this.count ? this.count[1] : 3
                },
                1366: {
                    items: this.count ? this.count[2] : 3
                }
            }
        };

        this.sliderObject = tns(options);

        const doRemoveFocusableItems = () => this.removeFocusableItems(Array.from(this.sliderObject.getInfo().slideItems));

        this.sliderObject.events.on('transitionStart', doRemoveFocusableItems);

        this.resizeFunction = debounce(() => {
            this.sliderObject.updateSliderHeight();
        }, 500);

        this.sliderObject.events.on('newBreakpointEnd', doRemoveFocusableItems);

        window.addEventListener('resize', () => {
            this.resizeFunction();
        });

        this.sliderObject.events.on('indexChanged', () => {
            const slide = new CustomEvent('change', Slider.getSlideCount(this.sliderObject.getInfo()));
            this.scope.dispatchEvent(slide);
        });

        this.sliderObject.events.on('newBreakpointEnd', () => {
            const slide = new CustomEvent('change', Slider.getSlideCount(this.sliderObject.getInfo()));
            this.scope.dispatchEvent(slide);
        });
    }

    bindPause() {
        if (this.pauseElement !== null && this.pauseElement !== undefined) {
            this.pauseElement.addEventListener('click', () => {
                this.pauseElement.querySelectorAll('span').forEach(span => {
                    span.classList.toggle('hidden');
                });
                if (this.isPlaying) {
                    this.stopAutoplay();
                } else {
                    this.startAutoplay();
                }
            });
        } else {
            console.error('Pause element is not defined.');
        }
    }

    startAutoplay() {
        this.isPlaying = true;
        this.autoplayInterval = setInterval(() => {
            this.sliderObject.goTo('next');
        }, this.autoplayTimeout);
    }

    stopAutoplay() {
        this.isPlaying = false;
        clearInterval(this.autoplayInterval);
    }

    indexButtons() {
        if (this.prevButton) {
            this.prevButton.tabIndex = 0;
            this.enterButton(this.prevButton);
        }
        if (this.nextButton) {
            this.nextButton.tabIndex = 0;
            this.enterButton(this.nextButton);
        }
    }

    enterButton(button) {
        button.addEventListener('keypress', e => {
            if (e.code === 'Enter') {
                setTimeout(() => document.querySelector('body').classList.add('keyboard-input'), 60);
            }
        });
    }

    static getSlideCount(slider) {
        return {
            detail: {
                count: slider.slideCount,
                visible: slider.items,
                index: slider.displayIndex
            }
        };
    }
}

